<template>
    <div class="d-flex align-items-stretch">
        <main-navigation></main-navigation>
        <div id="scheduled-send" class="w-100">
            <div class="main-content page-content scheduled-send-block">
                <div class="page-header">
                    <div>
                        <h3 class="page-title">{{ currentScheduledType === MASS_CATEGORY ? $t('massive-send') : $t('flash-send') }}</h3>
                        <p class="page-subtitle">{{ currentScheduledType === MASS_CATEGORY ? $t('send-sms-to-multiple-contacts') : $t('send-flash-messages') }}</p>
                    </div>
                </div>
                <div class="scheduled-send-menu d-flex align-items-end justify-content-between">
                    <ul class="page-tabs">
                        <li class="page-tab" :class="{ active: tabSelected === 'pending' }">
                            <router-link
                                :to="{ name: '' }"
                                @click.native="tabSelected = 'pending'"
                            >
                                {{ currentScheduledType === MASS_CATEGORY ? $t('planned-mass-message') : $t('planned-flash-message') }}
                                ({{ plannedScheduledMessages ? Object.keys(plannedScheduledMessages).length : 0 }})
                            </router-link>
                        </li>
                        <li class="page-tab" :class="{ active: tabSelected === 'messages-sent' }">
                            <router-link
                                :to="{ name: ''}"
                                @click.native="tabSelected = 'messages-sent'"
                            >
                                {{ currentScheduledType === MASS_CATEGORY ? $t('sent-mass-messages') : $t('sent-flash-messages') }}
                                ({{ sentScheduledMessages ? Object.keys(sentScheduledMessages).length : 0 }})
                            </router-link>
                        </li>
                    </ul>
                    <button
                        v-if="tabSelected === 'pending'"
                        class="btn btn-primary rounded-pill px-4 mb-2 add-btn"
                        :disabled="!sms.isEstablished"
                        @click="addScheduledMessage()">
                        {{ currentScheduledType === MASS_CATEGORY ? $t('add-massive-send') : $t('add-flash-send') }}
                    </button>
                </div>
                <!-- Massive section -->
                <div class="page-card" v-if="currentScheduledType === MASS_CATEGORY">
                    <pending-massive v-if="tabSelected === 'pending'" ref="pending"></pending-massive>
                    <sent-massive v-else></sent-massive>
                </div>

                <!-- Flash section -->
                <div class="page-card" v-else>
                    <pending-flash v-if="tabSelected === 'pending'" ref="pending"></pending-flash>
                    <sent-flash v-else></sent-flash>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

// Internal Components
import MainNavigation  from '@/core/components/MainNavigation.vue';
import PendingMassive  from './massive/Pending.vue';
import SentMassive     from './massive/Sent.vue';
import PendingFlash    from './flash/Pending.vue';
import SentFlash       from './flash/Sent.vue';

// Import external libraries
import { mapState } from 'vuex';

export default {
    components: {
        MainNavigation,
        PendingMassive,
        SentMassive,
        PendingFlash,
        SentFlash
    },
    data () {
        const MASS_CATEGORY  = 'mass';
        const FLASH_CATEGORY = 'flash';

        return {
            tabSelected: 'pending',
            MASS_CATEGORY,
            FLASH_CATEGORY
        };
    },
    watch: {
        currentScheduledType () {
            // Init the default selected tab for each scheduled type update
            this.tabSelected = 'pending';
        }
    },
    computed: {
        ...mapState('core/scheduled-messages', [
            'plannedScheduledMessages',
            'sentScheduledMessages'
        ]),

        ...mapState('core/connectors', [
            'sms'
        ]),

        currentScheduledType () {
            return this.$route.meta.category;
        }
    },
    methods: {
        addScheduledMessage () {
            if (this.currentScheduledType === this.MASS_CATEGORY) {
                this.$refs.pending.addMassMessage();
            } else {
                this.$refs.pending.addFlashMessage();
            }
        }
    }
};
</script>
